module.exports = __webpack_public_path__ + "img/CATS&DOG SPACE.b434f417.svg";